enum DefaultApps {
  formsViewKey = 'forms-view-saved-mode',
}

export default DefaultApps
